<template>
  <Catalog
    title="Статус объявления"
    name-label="Название статуса"
    submit-error="Укажите название статуса объявления."
    :fetch-data="fetchData"
    :put-data="putData"
    :post-data="postData"
    :exact-id="createId"
    v-on="$listeners"
  />
</template>

<script>
import catalogs from "../../../network/catalogs";
  import Catalog from "../Catalog.vue";

export default {
  name: "JobPostingStatus",
  components: { Catalog },
  mixins: [ catalogs ],
  props: {
    createId: { type: Number }
  },
  methods: {
    async fetchData(id) {
      return await this.getJobPostingStatusById(id);
    },
    async putData(data) {
      return await this.putJobPostingStatus(data)
    },
    async postData(data) {
      return await this.postJobPostingStatus(data)
    },
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Catalogs/JobPostingStatuses/JobPostingStatus.vue